import {
  WITHDRAW_LIST,
  ALL_GATEWAYS,
  SELECTED_GATEWAY,
  PLAYER_BANK_DETAILS,
} from "./types";

const initialState = {
  accountStatement: null,
  withdrawList: null,
  bonusListing: null,
  gatewaysList:
    sessionStorage.getItem("gatewayList") !== null
      ? JSON.parse(sessionStorage.getItem("gatewayList"))
      : null,
  selectedGateway:
    sessionStorage.getItem("selectedGateway") !== null
      ? JSON.parse(sessionStorage.getItem("selectedGateway"))
      : null,
  bankDetails: { banks: [], count: 0, pagesize: 10 },
};

export default (state = initialState, actions) => {
  const { type, payload } = actions;
  switch (type) {
    case WITHDRAW_LIST:
      return {
        ...state,
        withdrawList: payload,
      };
    case ALL_GATEWAYS:
      sessionStorage.setItem("gatewayList", JSON.stringify(payload));
      return {
        ...state,
        gatewaysList: payload,
      };
    case SELECTED_GATEWAY:
      sessionStorage.setItem("selectedGateway", JSON.stringify(payload));
      return {
        ...state,
        selectedGateway: payload,
      };
    case PLAYER_BANK_DETAILS:
      return {
        ...state,
        bankDetails: payload,
      };
    default:
      return state;
  }
};
